import React from 'react'
import { Typography } from '@material-ui/core'
import pessoaFisicaRepository from './PessoaFisicaRepository'
import RequisicaoCard from '../RequisicaoCard'
import moment from 'moment'

const PessoaFisicaCard = ({ match, cpf, disabled, validateFieldName }) => {
  const transform = query => ({
    ...query,
    cpf
  })

  const validateData = data => {
    if (!data) return 'ERROR'

    switch (data.situacaoCadastral) {
      case 'REGULAR':
        return { status: 'SUCCESS', message: '' }
      case 'PENDENTE DE REGULARIZACAO':
        return { status: 'WARNING', message: 'Pendente de regularização' }
      case 'SUSPENSA':
        return { status: 'WARNING', message: 'Suspensa' }
      case 'CANCELADA':
        return { status: 'ERROR', message: 'Cancelada' }
      case 'TITULAR FALECIDO':
        return { status: 'ERROR', message: 'Titular falecido' }
      default:
        return { status: 'ERROR', message: '' }
    }
  }

  return (
    <RequisicaoCard
      title="Pessoa Física Receita Federal"
      match={match}
      repository={pessoaFisicaRepository}
      transformManualFetch={transform}
      transformQuery={transform}
      disabled={disabled}
      validData={true}
      validateData={validateData}
      validateFieldName={validateFieldName}
    >
      {data => (
        <>
          {data.situacaoCadastral && (
            <Typography>Situação: {data.situacaoCadastral}</Typography>
          )}
          {data.nome && <Typography>Nome: {data.nome}</Typography>}
          {data.dataNascimento && (
            <Typography>
              Data de nascimento:{' '}
              {moment(data.dataNascimento).format('DD/MM/YYYY')}
            </Typography>
          )}
          {data.constaObito && <Typography>Consta Óbito</Typography>}
        </>
      )}
    </RequisicaoCard>
  )
}

export default React.memo(PessoaFisicaCard)
